export const MAPBOX_TOKEN = 'pk.eyJ1IjoiaGFubmVzamV3ZWwiLCJhIjoiY21kbG5iZzNtMTk5eTJrc2JkamV6NWR1bSJ9.hIgnw5jwYWxCEkYONC80Cg';